module.exports = __webpack_public_path__ + "media/images/ic-remove-destino-d010686a50a937bef4eb0e9e398517cf.svg";